import React, { memo } from 'react';
import { ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

import ModalLayout from '../ModalLayout';
import ElevatRadioButtons from '../ElevatRadioButtons';
import ServiceCompleteCard from './ServiceCompleteCard';
import { useBreakpoint } from '../../Context/BreakpointContext';
import { NoItemsFound } from '../NoDataIndication';

const propTypes = {
  acknowledgementQueue: PropTypes.object,
  assetShadowSignalsMap: PropTypes.object,
  error: PropTypes.string,
  handleCompleteMaintenance: PropTypes.func,
  isOpen: PropTypes.bool,
  now: PropTypes.object,
  processing: PropTypes.oneOf([true, false, 'complete']),
  resetReminder: PropTypes.bool,
  selectedCount: PropTypes.number,
  toggleModal: PropTypes.func,
  toggleResetReminder: PropTypes.func,
};
const defaultProps = {
  acknowledgementQueue: new Map(),
  error: '',
  handleCompleteMaintenance: () => {},
  isOpen: false,
  processing: false,
  resetReminder: true,
  selectedCount: 0,
  toggleModal: () => {},
  toggleResetReminder: () => {},
};

const ServiceCompleteModalDisplay = ({
  acknowledgementQueue,
  assetShadowSignalsMap,
  error,
  handleCompleteMaintenance,
  isOpen,
  now,
  processing,
  resetReminder,
  selectedCount,
  toggleModal,
  toggleResetReminder,
}) => {
  const radioData = [
    ['Stay on Default Schedule', false],
    ['Reset Reminder(s) from Current Interval', true],
  ];
  const radioConfig = {
    handleOnChange: toggleResetReminder,
    initialStatus: resetReminder,
    size: '14',
    orientation: 'stacked',
    disabled: !!processing || !acknowledgementQueue.size,
  };
  const { smMobile } = useBreakpoint();

  return (
    <ModalLayout centered isOpen={isOpen} scrollable toggle={toggleModal}>
      <ModalHeader toggle={toggleModal} className="border-bottom-0">
        <p className="font-weight-normal">
          Review Reminders{' '}
          <span className="nine-tenth-text text-icon-link-gray mx-1 rounded">
            {selectedCount} selected
          </span>
        </p>
      </ModalHeader>
      <ModalBody className="d-flex flex-column text-muted container-fluid py-0">
        <div
          className={`row ${
            smMobile ? 'three-quarter-text' : 'nine-tenth-text'
          }`}
          style={{ minHeight: '75px' }}
        >
          <div className="col">
            <ElevatRadioButtons data={radioData} config={radioConfig} />
          </div>
        </div>
        <div className="row" style={{ minHeight: '40px' }}>
          <p className="col text-text-light-gray">
            {`Reminder${acknowledgementQueue.size > 1 ? 's' : ''}`}
          </p>
        </div>
        <div className="row">
          <div className="col">
            {acknowledgementQueue.size ? (
              [...acknowledgementQueue].map(([triggerID, instance]) => (
                <ServiceCompleteCard
                  assetShadowSignalsMap={assetShadowSignalsMap}
                  instance={instance}
                  key={triggerID}
                  now={now}
                  processing={processing}
                  resetReminder={resetReminder}
                />
              ))
            ) : (
              <NoItemsFound text="No reminders selected" />
            )}
          </div>
        </div>
        <div className={error ? 'row' : 'd-none'}>
          <p className="col text-danger nine-tenth-text">{error}</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-sm btn-outline-secondary three-quarter-text px-4 py-1"
          onClick={toggleModal}
        >
          Cancel
        </button>
        <button
          className="btn modal-button-submit three-quarter-text px-4 py-1 m-0"
          onClick={handleCompleteMaintenance}
          disabled={!!processing || !acknowledgementQueue.size}
        >
          Complete Maintenance
        </button>
      </ModalFooter>
    </ModalLayout>
  );
};
ServiceCompleteModalDisplay.propTypes = propTypes;
ServiceCompleteModalDisplay.defaultProps = defaultProps;

export default memo(ServiceCompleteModalDisplay);
// Exports to ./ServiceCompleteModalContainer
